import { Component, OnInit } from '@angular/core';
import { Link } from 'src/app/shared/interfaces/link';
import { StoreService } from 'src/app/shared/services/store.service';
import { LegalService,LegalInfo } from '../legal.service';



@Component({
  selector: 'app-restaurant-footer',
  templateUrl: './restaurant-footer.component.html',
  styleUrls: ['./restaurant-footer.component.scss']
})
export class RestaurantFooterComponent implements OnInit {
  logo: string | null = null;
  nome: string | null = null;
   boxInfo: LegalInfo | undefined;

   infoLinks = [
    { label: 'Chi siamo', url: '/chi-siamo', no_follow: false },
    { label: 'Termini e Condizioni', url: 'https://www.mytidy.it/termini-e-condizioni', no_follow: true }
  ];

   socialLinks: { type: string; url: string; iconClass: string }[] = [];


  constructor( public storeService: StoreService,private legalService: LegalService) {}

  ngOnInit(): void {
    this.storeService.load().then(() => {
      this.logo = this.storeService.logo;
      this.nome = this.storeService.name;

    const iconMap: { [key: string]: string } = {
        facebook: 'fab fa-facebook-f',
        instagram: 'fab fa-instagram',
        youtube: 'fab fa-youtube',
        tiktok: 'fab fa-tiktok',
        linkedin: 'fab fa-linkedin-in',
        twitter: 'fab fa-x-twitter'
      };

      this.socialLinks = (this.storeService.link_social || []).map(link => ({
        type: link.type,
        url: link.url,
        iconClass: iconMap[link.type] || 'fas fa-globe'
      }));

       this.legalService.getBoxInformazioni().subscribe({
      next: (data) => {
        this.boxInfo = data;
      },
      error: (err) => {
        console.error('Errore caricamento box informazioni', err);
      }
      });
  });
  }

}
